export const imgixDomain = 'dpsrescue.imgix.net';
